// Formato de fechas único (hora de Madrid).
const FMT_FECHA = new Intl.DateTimeFormat("es-ES", {
  timeZone: "Europe/Madrid",
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});
const FMT_FECHA_HORA = new Intl.DateTimeFormat("es-ES", {
  timeZone: "Europe/Madrid",
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

export const fecha = (iso: string | null | undefined) => (iso ? FMT_FECHA.format(new Date(iso)) : "—");
export const fechaHora = (iso: string | null | undefined) =>
  iso ? FMT_FECHA_HORA.format(new Date(iso)) : "—";
